import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ConsultationDetailsPayload,
  ActionType,
  IConsultationDetailsResponse,
} from "models/consultations/consultationDetails";
import { httpStatus } from "configs/httpStatus";
import { getConsultationDetails } from "services/consultations";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./consultationDetailsActions";

function* consultationDetailsSaga({
  payload,
}: {
  payload: ConsultationDetailsPayload;
}) {
  try {
    const response: IConsultationDetailsResponse = yield call(
      getConsultationDetails,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetConsultationDetailsWatcher() {
  yield takeLatest(
    ActionType.GET_CONSULTATION_DETAILS as any,
    consultationDetailsSaga
  );
}

export default [fork(onGetConsultationDetailsWatcher)];
